var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "heart_svg__svg-safari-fix",
  viewBox: "0 0 11 10",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.972 9.488a.9.9 0 0 1-.555-.195C1.207 6.758.427 5.128.312 4.848c-.21-.4-.32-.85-.32-1.305 0-1.615 1.325-3.035 2.83-3.035.94 0 1.69.595 2.18 1.26.485-.665 1.24-1.26 2.18-1.26 1.51 0 2.83 1.42 2.83 3.035 0 .785-.395 1.43-.69 1.845-.345.495-1.4 2.01-3.795 3.905a.87.87 0 0 1-.55.195z"
})));
export default SvgHeart;